import React from "react";
import { Typography } from "top-brains-ui";
import PasswordImage from "@src/assets/password-success-img.svg";
import styles from "@src/pages/login/password-change-success/PasswordChangeSuccess.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import GradiantButton from "@src/components/gradiant-btn/GradiantButton";
import { useDispatch } from "react-redux";
import { setUserLogin } from "@src/app/globalSlice";
// import { WEBSITE_COLORS } from "@src/styles/ColorConstants";

const PasswordChangeSuccess: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();

  const handleSignInClick = () => {
    navigate("/");
    dispatch(setUserLogin(true));
  };

  return (
    <div className={styles.container}>
      <div>
        <Typography
          fontSize={26}
          fontWeight="semi-bold"
          color="var(--modal-heading-color)"
          className={styles.passwordSuccess}
        >
          {state?.from === "set-password"
            ? "Password Set Successfully"
            : "Password Changed Successfully"}
        </Typography>
      </div>
      <div className={styles.imageContainer}>
        <img src={PasswordImage} alt="password_img" />
      </div>
      <div className={styles.msgBody}>
        <div>
          <Typography fontSize={16} color="var(--modal-body-color)">
            New password has been set successfully you can now securely access
            your account with your new password.
          </Typography>
        </div>
      </div>
      <div className={styles.resendBtn}>
        <GradiantButton
          label="Back to Sign In"
          variant="primary"
          width="400px"
          height="44px"
          onClick={handleSignInClick}
          fontSize={16}
          className={styles.backToSignIn}
          labelClassName={styles.buttonLabel}
        />
      </div>
    </div>
  );
};

export default PasswordChangeSuccess;
